'use strict';

var BaseGroup = require('config/Group');
var i18n = require('i18next');
var RenderPositions = require('config/RenderPositions');

/**
 * "Port Forwarding" configuration group.
 */
module.exports = BaseGroup.extend({
  actionList: [
    {
      name: 'portForwardingRules',
      position: RenderPositions.full,
      required: true,
      renderTitle: false,
      renderStatic: true,
      doubleWide: false,
    },
  ],

  /**
   * @return {Boolean}
   */
  isRequired: function() {
    return true;
  },

  /**
   * @return {String}
   */
  title: function() {
    return i18n.t('groups.portForwarding');
  },

  /**
   * Overridden to prevent base Group class from trying to
   * combine multiple port forwarding rules into one
   */
  shouldMergeTasks: false,
});
